<template>
  <div>
    <div class="bannerStyle">
      <img src="@/assets/connecta.jpg" />
      <img src="@/assets/connectb.jpg" />
      <img src="@/assets/connectc.jpg" />
    </div>
    <div class="enter">
      <p class="p"><el-link href="/" :underline="false">首页</el-link> / 联系我们</p>
      <baidu-map :center="center" :zoom="zoom" :dragging="true" @ready="handler" class="map">
        <bm-marker :position="markerPoint" :dragging="dragging" :raiseOnDrag="raiseOnDrag"
          animation="BMAP_ANIMATION_BOUNCE"> </bm-marker>
      </baidu-map>
      <div class="connectBox">
        <h4>
          <span>联系方式</span>
        </h4>
        <p class="p1">
          <img src="@/assets/bordertop.jpg" /><br />
          联系地址
        </p>
        <p class="textCenter p2">
          上海市静安区寿阳路99弄2号楼 科翔高新三楼</p>
        <p class="p1"><img src="@/assets/bordertop.jpg" /><br />联系电话</p>
        <p class="textCenter p3">021-6221-5969</p>
      </div>
    </div>

    <div class="connectUs">
      <div class="enter connectBox">
        <h4>
          <span>欢迎留言</span>
        </h4>
        <el-form :model="form" ref="dynamicValidateForm" label-width="80px" style="width:700px;float:right;">
          <div style="display:flex;">
            <el-form-item label="姓名" prop="name" style="width: 50%;" :rules="[
              { required: true, message: '姓名不能为空', trigger: 'blur' }
            ]">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="tel" style="width: 50%;" :rules="[
              { required: true, message: '电话不能为空', trigger: 'blur' }
            ]">
              <el-input v-model="form.tel" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="邮箱" prop="email" :rules="[
              { required: true, message: '邮箱不能为空', trigger: 'blur' }
            ]">
            <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="留言信息" prop="desc" :rules="[
              { required: true, message: '留言信息不能为空', trigger: 'blur' }
            ]">
            <el-input type="textarea" v-model="form.desc" placeholder="请输入留言信息"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" round size="small"
              @click="onSubmit('dynamicValidateForm')">&nbsp;&nbsp;&nbsp;提交&nbsp;&nbsp;&nbsp;</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        center: {
          lng: 0,
          lat: 0
        }, // 设置中心点信息
        zoom: 3, // 地图初始放大倍数
        markerPoint: {
          lng: 121.459698,
          lat: 31.296816
        }, // 点的位置
        dragging: true, // 是否可以拖拽点
        raiseOnDrag: true, // 拖拽时是否有动画效果

        form: {
          name: '',
          tel: '',
          email: '',
          desc: ''
        }
      }
    },
    created() {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    },
    methods: {
      // 创建地图
      handler({
        BMap,
        map
      }) {
        map.enableScrollWheelZoom(true);
        this.center.lng = 121.466132;
        this.center.lat = 31.302998;
        this.zoom = 18;
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form = {};
            this.$message({
              message: '留言成功，谢谢您的反馈',
              type: 'success'
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
  }
</script>
<style scoped>
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }

  .enterImg {
    margin-top: 50px;
  }

  .enterImg img {
    width: 100%;
    display: block;
  }

  .enter {
    width: 950px;
    margin: auto;
    display: table;
  }

  .enter .p {
    font-size: 14px;
    padding: 30px 0;
  }

  .enter .p a {
    font-size: 14px;
  }

  .map {
    width: 950px;
    height: 432px;
    margin-bottom: 50px;
  }

  .textCenter {
    text-align: center;
    font-weight: bold;
  }

  .connectBox h4 span {
    font-size: 16px;
    border-bottom: 2px solid #C01921;
    padding: 5px 0;
  }

  .connectBox .p1 {
    text-align: center;
    padding: 40px 0 6px 0;
    font-size: 14px;
  }

  .connectBox .p1 img {
    width: 14px;
    padding-bottom: 10px;
  }

  .connectBox .p2 {
    font-size: 16px;
    color: #333;
  }

  .connectBox .p3 {
    font-size: 22px;
    color: #C01920;
    margin-bottom: 50px;
  }

  .connectUs {
    background: #EFF3F4;
    padding: 66px 0;
  }

  .connectUs h4 {
    width: 80px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/connectUs.vue